import { Heart } from "lucide-react";
import { useFavorites } from "../../hooks/useFavorites";

export default function FavoriteButton({ id, className = "", light = false }) {
  const { isFav, toggle } = useFavorites();
  const active = isFav(id);
  return (
    <button
      data-testid={`fav-btn-${id}`}
      aria-label={active ? "Remove from saved" : "Save home"}
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); toggle(id); }}
      className={`grid place-items-center w-10 h-10 backdrop-blur-md transition-colors duration-300 ${
        light ? "bg-white/90 hover:bg-white" : "bg-[#FAF9F6]/90 hover:bg-white"
      } ${className}`}
    >
      <Heart size={17} className={active ? "fill-[var(--gold)] text-[var(--gold)]" : "text-[#0A1128]"} />
    </button>
  );
}
